"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortContext = void 0;
class AbortContext {
    constructor() {
        this._isAborted = false;
        this._abortHandler = [];
    }
    abort() {
        var _a;
        if (this._isAborted) {
            return;
        }
        (_a = this._abortHandler) === null || _a === void 0 ? void 0 : _a.forEach(handler => handler());
        this._isAborted = true;
        this._abortHandler = undefined;
    }
    renew() {
        this.abort();
        return new AbortContext();
    }
    newAbortSignal(abortController) {
        if (this._isAborted) {
            abortController.abort();
            return abortController.signal;
        }
        this.addAbortHandler(() => {
            abortController.abort();
        });
        return abortController.signal;
    }
    get isAborted() {
        return this._isAborted;
    }
    addAbortHandler(value) {
        var _a;
        (_a = this._abortHandler) === null || _a === void 0 ? void 0 : _a.push(value);
    }
}
exports.AbortContext = AbortContext;
